import { render } from "./translatedErrors.vue?vue&type=template&id=1e61a791"
import script from "./translatedErrors.vue?vue&type=script&lang=js"
export * from "./translatedErrors.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__